import { URL_CONST } from 'utils/urlConsts'

export const REGULAR_FILTERS_CHANGE = 'ResolutionCenter/IncidentFilters/REGULAR_FILTERS_CHANGE'
export const REGULAR_FILTERS_SUBMIT = 'ResolutionCenter/IncidentFilters/REGULAR_FILTERS_SUBMIT'

export const LAST_24_HOURS = 3
export const LAST_3_DAYS = 4
export const LAST_7_DAYS = 5
export const LAST_30_DAYS = 6
export const ALL_TIMES = 7

export const INCIDENT_DATE_FILTERS_OPTIONS = [
  { value: LAST_24_HOURS, label: 'Last 24 hours', shorterLabel: 'Last 24h' },
  { value: LAST_3_DAYS, label: 'Last 3 days', shorterLabel: 'Last 3d' },
  { value: LAST_7_DAYS, label: 'Last 7 days', shorterLabel: 'Last 7d' },
  { value: LAST_30_DAYS, label: 'Last 30 days', shorterLabel: 'Last 30d' },
  { value: ALL_TIMES, label: 'All times', shorterLabel: 'All times' },
]

export const DETECTED_BY_FILTER_OPTIONS = [
  { value: 1, label: 'IRONSCALES Community' },
  { value: 2, label: 'Impersonation Protection' },
  { value: 3, label: 'End User' },
  { value: 4, label: 'Malware & URL Protection' },
  { value: 5, label: 'Automated Threat Detection' },
  { value: 6, label: 'SOC Analyst' },
  // The AI-Bubble Up agent's incidents (report_consts.AGENTIC_THEMIS_FILTER_ID).
  { value: 7, label: 'Agentic Themis' },
]

export const INCLUDES_FILTER_OPTIONS = [
  { value: 1, label: 'Links' },
  { value: 2, label: 'Fake Login' },
  { value: 3, label: 'Attachments' },
  { value: 4, label: 'Internal Comments' },
  { value: 5, label: 'Community Comments' },
]

export const INCLUDE_FILTER_BUBBLE_UPS = { value: 6, label: 'Bubble Ups' }
export const INCLUDING_AUTO_THEMIS_POTENTIAL_REPORTS = { value: 7, label: 'Auto Themis (below TH)' }
export const INCLUDE_FILTER_PHISHING_SOC_AGENT = { value: 8, label: 'Phishing SOC Agent' }

export const RESOLVED_BY_FILTER = {
  AUTOMATICALLY: { value: 1, label: 'Automatically' },
  MANUALLY: { value: 2, label: 'Manually' },
}

export const RESOLVED_BY_FILTER_OPTIONS = [
  RESOLVED_BY_FILTER.AUTOMATICALLY,
  RESOLVED_BY_FILTER.MANUALLY,
]

export const INCLUDE_CONST = 1
export const EXCLUDE_CONST = 2

export const getIsUnclassified = () =>
  window.location.pathname.includes(URL_CONST.incidents.unclassified)

export const getIsClassified = () =>
  window.location.pathname.includes(URL_CONST.incidents.classified)

export const getIsChallenged = () =>
  window.location.pathname.includes(URL_CONST.incidents.challenged)

/**
 * Tabs that leave `dateFilter` unset so the UI/request use favorite → company default.
 *
 * LAST_24_HOURS is only stamped on **legacy Challenged** (no time-frame UI; count
 * polling for openIncidents). Every other path — Unclassified, Classified, redesign
 * Challenged, Reports, Scan Back — stays unset. Stamping 24h on Reports/Scan Back
 * leaked into incidents after a refresh + navigate-back because the redesign
 * keeps regularFilters (`preserveFilters`); legacy List remounts and clears via
 * `regularFiltersChange([], 'all')`.
 *
 * @param {boolean} [incidentsRedesignEnabled]
 */
export const getUsesEffectiveIncidentDateFilter = (incidentsRedesignEnabled = false) =>
  !getIsChallenged() || !!incidentsRedesignEnabled
